import { ParameterSelect } from "@/components/atoms/ParameterSelect";
import { ConfigurationParametersInputProps, ParameterInputProps } from ".";
import { useState } from "react";

export function FallbackConfigurationParametersInput({
    parameters,
    values,
    onChange,
    fullConfiguration
}: Readonly<ConfigurationParametersInputProps>) {

    return (
        <>
            {parameters?.map((parameter, i) => (
               <FallbackConfigurationParameterInput
                    key={parameter.id}
                    parameter={parameter}
                    value={values[i]}
                    onChange={(value) => onChange(i, value)}
                    fullConfiguration={fullConfiguration}
                />
            ))}
        </>
    )
}

export function FallbackConfigurationParameterInput({ parameter, value, onChange }: Readonly<ParameterInputProps>) {
    const [parameterOptions, setParameterOptions] = useState(parameter.options);
    return (
        <div className="space-y-2">
            <label className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70">
                {parameter.name}
            </label>
            <ParameterSelect
                parameterData={{ ...parameter, options: parameterOptions }}
                value={value}
                onChange={onChange}
                onCreate={(newOption) => {
                    setParameterOptions([
                        ...(parameter.options ?? []),
                        {
                            value: newOption,
                            key: newOption
                        }
                    ]);
                    onChange(newOption);
                }}
            />
        </div>
    )
}
